import React from 'react';
import { Switch } from 'antd';
import Text from 'components/Text/Text';
import OutsideFormInput from 'components/Input/OutsideFormInput';
import classNames from 'classnames';
import style from './InclusiveProductItem.module.scss';

interface IProps {
	productId: string;
	name: string;
	inclusive: number;
	isEnabled: boolean;
	onToggle: (productId: string, isEnabled: boolean) => void;
	onChangeValue: (productId: string, value: number) => void;
}

export const InclusiveProductItem: React.FC<IProps> = ({
	productId,
	name,
	inclusive,
	isEnabled,
	onToggle,
	onChangeValue,
}) => {
	const handleToggle = (checked: boolean) => {
		onToggle(productId, checked);
	};

	const switchClasses = classNames({ [style.switchActive]: isEnabled });

	return (
		<div className={style.container} data-test="InclusiveProductItem">
			<div className={style.header}>
				<Text className={style.productName} translationKey={name} size="s" withTooltip={true} />
				<div className={style.switchWrapper}>
					<Switch className={switchClasses} checked={isEnabled} onChange={handleToggle} />
					<Text
						className={style.switchLabel}
						translationNameSpace="form"
						translationKey="inclusiveLabel"
						size="xs"
						theme={isEnabled ? 'neutralLight' : 'secondaryLight'}
					/>
				</div>
			</div>
			{isEnabled && (
				<OutsideFormInput
					name="inclusive"
					label="inclusiveLabel"
					type="number"
					min={0}
					numberValue={inclusive}
					onChangeNumber={(value) => onChangeValue(productId, value ?? 0)}
					placeholder="enterAValuePlaceholder"
					containerClassName={style.inputWrapper}
					className={style.input}
					withValidation={false}
				/>
			)}
		</div>
	);
};
